import { ReactNode } from 'react'
import React from 'react'

import { twMerge } from 'tailwind-merge'

import { Url } from '@/types'
import Button from '@components/Button'
import { Icon } from '@components/Icon'

interface CardDescriptionProps {
  children: ReactNode
  className?: string
  url?: Url
}

const CardDescription: React.FC<CardDescriptionProps> = ({
  children,
  className,
  url,
}) => {
  if (!url) {
    return (
      <div className={twMerge(className, 'text-balance line-clamp-2')}>
        {children}
      </div>
    )
  }

  return (
    <div className={className}>
      <Button
        href={url?.href || undefined}
        target={url?.target || undefined}
        variant="inlineLink"
        className="inline"
        icon={null}
      >
        <span className="line-clamp-2 text-balance break-words">
          {children}
          <Icon
            name="arrow"
            className="text-[#EB0000] inline-block align-middle ml-2"
            size={14}
          />
        </span>
      </Button>
    </div>
  )
}

export default CardDescription
